<template>
  <div class="ex-info">
    <div>
      <template v-if="list && list.items && list.items.length">
        <div class="my-item3" style="padding-bottom:60px;">
          <Row :gutter="30">
            <Col span="8" v-for="(item, index) in list.items" :key="'my-item3' + index">
              <div class="my-item3-box">
                <div class="item-show" v-if="!item.isShow">
                  <i class="icon iconfont icon-hide"></i>
                </div>
                <div class="mi-content">
                  <div class="mi-content-top">
                    <div class="mi-content-top-left">
                      <img v-if="item.headImg" :src="item.headImg" class="logo" />
                      <img v-else src="@assets/img/empty.png" class="logo" />
                      <p class="txt" :title="item.subtitle">{{item.subtitle}}</p>
                    </div>
                    <div class="mi-content-top-right" v-if="item.brand">
                      <div class="brand" :style="{color: item.brand.color}">{{item.brand.name}}  {{item.type2 ? '/' + item.type2: ''}}</div>
                    </div>
                  </div>
                  <div class="mi-content-date">
                    <Row :gutter="30">
                      <Col span="12">
                        <span class="left">提交时间：{{item.inTime | moment("YYYY/MM/DD HH:mm:ss")}}</span>
                      </Col>
                      <Col span="12">
                        <span class="right">浏览：{{item.viewCount}} 分享：{{item.shareCount}}</span>
                      </Col>
                    </Row>
                  </div>
                  <div class="mi-content-imglist" v-if="item.photo && item.photo.length">
                    <img
                      class="img-item"
                      :src="i"
                      v-for="(i, idx) in item.photo"
                      v-if="idx < 3"
                      :key="'img-item' + idx"
                    />
                  </div>
                  <div class="mi-content-txt" style="padding-top:0;text-overflow:ellipsis;white-space: nowrap;display:block;">手机号：{{item.phone}}</div>
                  <div :title="item.sourceName" class="mi-content-txt" style="padding-top:10px;text-overflow:ellipsis;white-space: nowrap;display:block;">
                    来源：{{item.sourceName}}
                    <template v-if="item.sourceType">
                      （{{item.sourceType}}）
                    </template>
                  </div>
                  <div class="mi-content-txt" style="word-wrap:break-word;padding-top:10px;">{{item.information}}</div>
                </div>
                <div class="mi-tool">
                  <div class="mi-tool-item" @click="changeHandle(item)">处理</div>
                  <div class="mi-tool-line">|</div>
                  <!-- <div class="mi-tool-item" @click="setTopic(item)">推荐</div>
                  <div class="mi-tool-line">|</div>-->
                  <div class="mi-tool-item">
                    <Dropdown trigger="custom" :visible="item.visible">
                      <a
                        href="javascript:void(0)"
                        style="color:#808080;"
                        @click="toggleOpen(index)"
                      >
                        更多
                        <Icon type="ios-arrow-down"></Icon>
                      </a>
                      <DropdownMenu slot="list" style="text-align:center;">
                        <DropdownItem v-if="item.isShow" @click.native="showOff(item)">屏蔽</DropdownItem>
                        <DropdownItem v-else @click.native="showOn(item)">显示</DropdownItem>
                        <DropdownItem>
                          <Poptip
                            confirm
                            placement="top-start"
                            title="确认删除此项目吗 ?"
                            @on-ok="delItem(item, index)"
                            @on-cancel="handleClose(index)"
                          >
                            <div style="width: 100px;">删除</div>
                          </Poptip>
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div class="my-page" v-if="totalCount > pageSize" style="text-align:center;padding: 20ppx;">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </template>
      <div class="u-empty" v-else style="margin: 30px;">暂无数据</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "supply-user-info-check",
  props: {
    releaseType: {
      type: String,
      default: ""
    },
    status: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      editTopic: false,
      editTopicnfo: null,

      list: null,
      pageSize: 12,
      list2: [],
      pageIndex: 1,
      totalCount: 0
    };
  },
  created() {
    this.init();
  },
  watch: {
    status(val, oldVal) {
      this.init();
    }
  },
  computed: {
    option() {
      return {
        // ExhibitionId: this.exhibitionInfo.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 0,
                  Label: "isHandle",
                  Value: this.status === "1" ? true : false
                }
              },
              {
                type: 1,
                wheres: {
                  WhereOperator: 0,
                  Label: "fromType",
                  Value: 1
                }
              },
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "typeId",
                  Value: `%${this.releaseType}%`
                }
              }
            ]
          }
        }
      };
    },
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  methods: {
    ...mapActions({
      getReleaseType: "momentModule/getReleaseType",
      getReleaseByExhibition: "releaseModule/getReleaseByExhibition",
      delRelease: "releaseModule/delRelease",
      editReleaseStatus: "releaseModule/editReleaseStatus",
      editReleaseShow: "releaseModule/editReleaseShow",
      editReleaseHandle: "releaseModule/editReleaseHandle"
    }),
    setTopic(item) {
      // 设置置顶
      this.editTopicnfo = item;
      this.editTopic = true;
    },
    async init() {
      let listData = await this.getReleaseType(this.exhibitionInfo.id);
      if (listData && listData.length) {
        this.list2 = listData;
      }
      let exData = await this.getReleaseByExhibition(this.option);
      if (exData) {
        exData.items.map(c => {
          if (c.typeInfo) c.typeInfo = JSON.parse(c.typeInfo);
          if (c.photo && c.photo.indexOf("[") !== -1)
            c.photo = JSON.parse(c.photo);
          this.list2.forEach(v => {
            if (v.id === c.typeId) {
              c.brand = v;
            }
          });
          c.visible = false;
        });
        this.list = exData;
        this.pageSize = exData.pageSize;
        this.pageIndex = exData.pageIndex;
        this.totalCount = exData.totalCount;
      }
    },
    // 修改展品显示、屏蔽
    async showOff(item) {
      let result = await this.editReleaseShow({ id: item.id, bool: false });
      if (result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    async showOn(item) {
      let result = await this.editReleaseShow({ id: item.id, bool: true });
      if (result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    async delItem(item) {
      let result = await this.delRelease(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    async changeHandle(item) {
      let result = await this.editReleaseHandle(item.id);
      if (result.successed) {
        this.$Message.success("操作成功");
        this.init();
      } else {
        this.$Message.error("操作失败，请重新尝试");
      }
    },
    async changeStatus(item) {
      const req = {
        Id: item.id,
        StatusId: "1"
      };
      let result = await this.editReleaseStatus(req);
      if (result.successed) {
        this.$Message.success("操作成功");
        this.init();
      } else {
        this.$Message.error("操作失败，请重新尝试");
      }
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.init();
    },

    handleOpen(index) {
      this.list.items[index].visible = true;
    },
    handleClose(index) {
      this.list.items[index].visible = false;
    },
    toggleOpen(index) {
      let visible = this.list.items[index].visible;
      this.list.items[index].visible = !visible;
    }
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style scoped lang="scss">
.ex-info {
  &-top {
    width: 100%;
    min-height: 100px;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    padding: 20px 24px 0 36px;
    &-l {
      height: 100%;
      display: flex;
      flex-direction: column;
      .s1 {
        flex: 1;
        font-size: 14px;
        color: #8c8c8c;
      }
      .h1 {
        flex: 1;
        font-size: 18px;
        color: #333;
        font-weight: bold;
      }
      .s2 {
        flex: 1;
        font-size: 14px;
        color: #333;
      }
    }
    &-r {
      &-box {
        width: 150px;
        height: 80px;
        border: 1px dashed #1890ff;
        background-color: #e7f4ff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .I1 {
          font-size: 16px;
          font-weight: bold;
          color: #1890ff;
        }
        .s3 {
          font-size: 14px;
          color: #1890ff;
          margin-left: 9px;
        }
      }
    }
  }
  &-content {
    min-width: 1000px;
    padding: 30px;
    padding-bottom: 50px;
  }
  &-list {
    width: 100%;
    display: inline-block;
    background-color: #fff;
    margin-bottom: 30px;
    &-img {
      width: 100%;
      padding-bottom: 66.666667%;
      position: relative;

      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
    &-title {
      padding-left: 10px;
      font-size: 14px;
      color: #1a1a1a;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 31px;
      background: #fff;
      height: 66px;
      padding: 10px 10px 7px 12px;
    }
    &-time {
      width: 300px;
      min-height: 27px;
      padding-left: 10px;
      font-size: 14px;
      color: #fe791e;
    }
  }
}
.pro {
  &-tool {
    display: flex;
    height: 48px;
    align-items: center;
    justify-content: space-around;
    background-color: #f7f9fa;

    &-item {
      flex: 1;
      line-height: 48px;
      font-size: 14px;
      color: #808080;
      cursor: pointer;
      text-align: center;
      &:hover {
        color: #1890ff;
      }

      &.z-del {
        &:hover {
          color: #f00;
        }
      }
    }

    &-line {
      background-color: #e8e8e8;
      font-size: 20px;
      width: 1px;
      height: 22px;
    }
  }
}
</style>